import * as React from "react";
import PropTypes from "prop-types";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useSpring, animated } from "@react-spring/web";
import Heading from "app/components/Heading";
import {
  ImageListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Div from "@jumbo/shared/Div";
let imagepath = process.env.REACT_APP_IMAGE_URL;
const Fade = React.forwardRef(function Fade(props, ref) {
  const {
    children,
    in: open,
    onClick,
    onEnter,
    onExited,
    ownerState,
    ...other
  } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter(null, true);
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited(null, true);
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {React.cloneElement(children, { onClick })}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element.isRequired,
  in: PropTypes.bool,
  onClick: PropTypes.any,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
  ownerState: PropTypes.any,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 5,
};

function TextFeild({ label, value, sx }) {
  return (
    <Typography id="SupplierName" sx={{ mt: 0, letterSpacing: 0.5, ...sx }}>
      <Typography as="span" sx={{ fontWeight: 600 }}>
        {label}
      </Typography>{" "}
      :- {value}
    </Typography>
  );
}

export default function ViewModel({ open, setOpen, sampleDetails }) {
  // console.log(sampleDetails, "----------------------------------------");
  const handleClose = () => setOpen(false);
  return (
    <div>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography sx={{ my: 2 }}>
              <Heading Name={"View Sample Details"} />
            </Typography>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              sx={{ my: 4 }}
            >
              <Box>
                <Typography id="spring-modal-title" variant="h1" component="h1">
                  Contact Details
                </Typography>
                <TextFeild
                  label={`Person Name `}
                  value={`${sampleDetails?.state?.contactDetails?.personName}`}
                />
                <TextFeild
                  label={"Email Id"}
                  value={`${sampleDetails?.state?.contactDetails?.email}`}
                />
                <TextFeild
                  label={"Mobile Number"}
                  value={`${sampleDetails?.state?.contactDetails?.mobileNo}`}
                />
                <TextFeild
                  label={"GST Number"}
                  value={`${
                    sampleDetails?.state?.contactDetails?.gstNo
                      ? sampleDetails?.state?.contactDetails?.gstNo
                      : "XXXXXXXXXXX"
                  }`}
                />
              </Box>
              <Box>
                <TextFeild
                  label={"Address"}
                  value={` ${sampleDetails?.state.address?.address} `}
                />
                <TextFeild
                  label={"Area"}
                  value={`${sampleDetails?.state?.address?.area}`}
                />
                <TextFeild
                  label={"Location"}
                  value={`${sampleDetails?.state?.address?.location}`}
                />
                <TextFeild
                  label={"District"}
                  value={`${sampleDetails?.state?.address?.district}`}
                />
                <TextFeild
                  label={"Taluka"}
                  value={`${sampleDetails?.state?.address?.taluka} `}
                />
                <TextFeild
                  label={"City"}
                  value={`${sampleDetails?.state?.address?.city}`}
                />
                <TextFeild
                  label={"State"}
                  value={`${sampleDetails?.state?.address?.state}`}
                />
                <TextFeild
                  label={"Pincode"}
                  value={`${sampleDetails?.state?.address?.pincode} `}
                />
              </Box>
            </Box>
            <Box sx={{ my: 4 }}>
              <Typography
                id="spring-modal-title"
                variant="h1"
                component="h2"
                sx={{ my: 2 }}
              >
                Item Details
              </Typography>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: "#7352C7", color: "white" }}>
                      {[
                        "Items Name",
                        "Category",
                        "SKU",
                        "HSN Code",
                        "Date",
                        "Quantity",
                      ].map((ele, i) => {
                        return (
                          <>
                            <TableCell
                              align="left"
                              sx={{
                                textTransform: "capitalize",
                                color: "white",
                                textAlign: "left",
                                minWidth: "150px",
                                verticalAlign: "middle",
                              }}
                            >
                              {ele}
                            </TableCell>
                          </>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left">
                        {sampleDetails?.state?.items[0]?.product_name || "NA"}
                      </TableCell>
                      <TableCell align="left">
                        {sampleDetails?.state?.items[0]?.category || "NA"}
                      </TableCell>
                      <TableCell align="left">
                        {sampleDetails?.state?.items[0]?.sku || "NA"}
                      </TableCell>
                      <TableCell align="left">
                        {sampleDetails?.state?.items[0]?.hsn_code || "NA"}
                      </TableCell>
                      <TableCell align="left">
                        {sampleDetails?.state?.dateofsample || "NA"}
                      </TableCell>
                      <TableCell align="left">
                        {sampleDetails?.state?.items[0]?.quantity || "NA"}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
